/**
 * @generated SignedSource<<bff1c61f13419ff888fd8c7de4d85bf6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpLayoutHorizontalAlignment = "CENTER" | "LEFT" | "RIGHT" | "%future added value";
export type HelpLayoutVerticalAlignment = "BOTTOM" | "MIDDLE" | "TOP" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type alignmentSettingsContextFragment$data = {
  readonly alignment: {
    readonly __id: string;
    readonly horizontalAlignment: HelpLayoutHorizontalAlignment | null | undefined;
    readonly verticalAlignment: HelpLayoutVerticalAlignment | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "alignmentSettingsContextFragment";
};
export type alignmentSettingsContextFragment$key = {
  readonly " $data"?: alignmentSettingsContextFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"alignmentSettingsContextFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "alignmentSettingsContextFragment",
  "selections": [
    {
      "concreteType": "HelpLayoutAlignmentSettings",
      "kind": "LinkedField",
      "name": "alignment",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "horizontalAlignment"
        },
        {
          "kind": "ScalarField",
          "name": "verticalAlignment"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__id"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpLayoutVisualConfig"
};

(node as any).hash = "e8bd7e9e63e3ee57f31e69ea25b912df";

export default node;
